<template>
<!-- THIS WILL UTILISE A 'FULLSCREEN' DIALOG (LOOK ON VUETIFY COMPONENT DOCS TO UNDERSTAND) -->
    <v-card>
        <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialogClosed()">
            <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{getLabel}} Organisation</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
            <v-btn icon v-if="myOrg" dark text @click="openChat()"><v-icon>mdi-chat</v-icon></v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card
        class="overflow-y-auto overflow-x-hidden"
        height="93vh"
        >
            <v-container fluid>                  
                <v-row dense>
                    <v-col cols="12" md="12">
                        <v-card height="100%">
                            <v-row>
                                <v-col cols="12" md="2">
                                    <v-card-title color="primary">Organisation Info</v-card-title>
                                    <v-card-text>Name: {{localOrg.name}} </v-card-text>
                                    <v-card-text>Address: {{localOrg.location}}</v-card-text>
                                    <v-card-text>Bio: {{localOrg.bio}}</v-card-text>
                                </v-col>
                                <v-col cols="12" md="10">
                                    <user-management v-if="isAdmin" :organisation="localOrg" :users="userItems" :usersLoading="usersLoading"></user-management>
                                </v-col>
                            </v-row>
                            <v-row wrap>

                                <v-col cols="12" md="4">
                                    <v-card-title color="primary">Organisation Stats</v-card-title>
                                    <v-row wrap>
                                        <v-col cols="12" md="6">
                                            <v-card-subtitle color="primary">Total Treatments: {{orgStats.totalTreatments}} </v-card-subtitle>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-card-subtitle color="primary">Total Upvotes: {{orgStats.totalUpvotes}} </v-card-subtitle>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" md="8">
                                    <v-card-title color="primary">Specialties: </v-card-title>
                                    <pie-chart ref='categoryChart' :data="categoryData" :options="categoryChartOptions"/>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>

        <v-dialog v-model="chatDialog" :retain-focus="false" fullscreen class="overflow-x-hidden" hide-overlay transition="slide-x-transition">              
            <chat-dialog
            v-if="chatDialog"
            v-on:dialogClosed="closeChatDialog()"
            :chatId="currentChat.id"
            :userIds="currentChat.userIds"
            :userId="this.$route.params.userDb.uid">
            </chat-dialog>
        </v-dialog>
    </v-card>

</template>

<script>
import PieChart from './../Charts/PieChart.vue'
import ChatDialog from './../Chat/ChatDialog.vue'
import fb from '@/fb';
import UserDataService from './../../services/userDataService.js';
import TreatmentDataService from './../../services/treatmentDataService.js'
import UserManagement from './../Management/UserManagement/UserManagement.vue'
import ChatDataService from './../../services/chatDataService.js';
import Toast from './../../plugins/customToast.js';

export default {
    name: 'organisationScreen',
    components: {
        PieChart,
        UserManagement,
        ChatDialog
    },
    props: {
        user: Object,
        org: Object,
        label: String
    },
    mounted() {
        this.userDataService = new UserDataService();
        this.treatmentDataService = new TreatmentDataService();
        this.chatDataService = new ChatDataService();
        //We also place a watcher on this to keep an eye out for when any changes on the initial treatment occur?
        if (this.user){
            this.localUser = this.user;
            if (this.org){
                this.localOrg = this.org;
                //Load method, that includes getting the organisations treatments
                this.load();
            }
        }
    },
    methods: {     
        load(){
            this.treatmentLoading = true;
            this.usersLoading = true;

            var that = this;
            //First call the treatment list, if it has been resolved (loaded, then we can load the user list)
            this.loadTreatments()
            .then(function(done){
                //Finish the treatment loading
                that.treatmentLoading = !done;

                //Now we can load the users
                that.loadUsers()
                .then(function(done){
                    that.usersLoading = !done;
                });
            });
        },
        loadStats(){
            this.resetOrgStats();
            this.populateOrgStats();
        }, 
        loadTreatments(){
            var that = this;
            return new Promise(function(resolve){
                //May need to refactor this into a method within the treatmentDataService
                fb.db.collection('treatments').where("organisation", "==", that.localOrg.id)
                .onSnapshot(res => {
                    const changes = res.docChanges();

                    changes.forEach(change => {
                        if (change.type === 'added'){
                            that.treatmentItems.push({id: change.doc.id, data: change.doc.data()}); //Do we need a spread operator here?
                        }
                    })
                    resolve(true);
                    that.loadStats();
                })
            });
        },
        loadUsers(){
            var that = this;
            return new Promise(function(resolve){
                //Get the list of ids to load
                var idList = that.localOrg.users.map(u => u.id);
                //We'd load all the user info in here using the userDataService
                that.userDataService.searchFirebaseByUserIdList(idList)
                .then(function(returnedUsers){
                    //If this is successfully resolved, we then have to put the users into our custom local format
                    //We can do this by mapping again to put it into a unique local format users: {id, userInfo, admin}
                    that.userItems = returnedUsers.map(u => ({id: u.uid, data: u, admin: that.isAdmin(u.uid)}))
                    resolve(true);
                }).catch(function(error){
                    Toast.fire({  icon: 'error',  title: `Error loading users: ${error}`});
                });
            })
        },
        populateOrgStats(){
            var that = this;
            this.orgStats.totalTreatments = this.treatmentItems.length;
            //Loop through all of these treatments
            this.treatmentItems.forEach(function (treatment){
                //Then loop through the current treatments categories
                treatment.data.category.forEach(function (category){
                    //(check if this treatment matches any existing categories)
                    if (that.orgStats.categories.some(element => element.name === category))
                    {
                        //Find the index value now we know it exists:
                        const index = that.orgStats.categories.findIndex(element => element.name === category);
                        //If they match, just increment this orgStatCategories amount
                        that.orgStats.categories[index].count++; 
                    } else {
                        //Otherwise, add this as a new organisation stat category
                        that.orgStats.categories.push({name: category, count: 1});
                    }
                })
                that.orgStats.totalUpvotes = that.orgStats.totalUpvotes + treatment.data.upvotes;
            });

            this.populateCategoryData(this.orgStats.categories);
        },
        resetOrgStats(){
            this.orgStats = {
                totalTreatments: 0,
                totalUpvotes: 0,
                categories: [{name: "Other", count: 0}]
            }
            this.resetCategoryData();
        },
        populateCategoryData(categories){
            var that = this;
            this.resetCategoryData();
            categories.forEach(function (category){
                that.categoryData.labels.push(category.name);
                that.categoryData.datasets[0].data.push(category.count);
                that.categoryData.datasets[0].backgroundColor.push(that.random_rgba());
            })
            this.$refs.categoryChart.renderChart(that.categoryData, that.categoryChartOptions);
        },
        resetCategoryData(){
            this.categoryData = {
                labels: [],
                datasets: [
                    {
                    label: 'Categories',
                    backgroundColor: [
                    ],
                    data: []
                    }
                ]
            }
        },
        refreshLocalOrg(){
            //We can just call load again?
        },
        dialogClosed(){
            this.resetOrgStats();
            //Emit so that the parent call knows that the dialog has closed
            this.$emit("dialogClosed");
        },
        openChat(){
           //Just do a normal get/search for the chat (if it exists with the expected user id's and chat type --> then just open that current chat with the chatID just obtained)
            if (this.localOrg.id){                
                this.chatDataService.getExistingChat(null, "Group", this.localOrg.id)
                .then(chatDoc => {
                    //for organisations, if the chat does exist (using orgID) but the user can't be found --> Join the existing chat, retain the id and open the chat as normal
                    if (!chatDoc.data.users.includes(this.localUser.uid))
                    {
                        //If the user can't be found, join the existing chat
                        this.chatDataService.joinExistingChat(this.localUser.uid, chatDoc.id)
                        .then(() => {
                            //Then open the chat as normal, with the appended localUser.uid
                            this.currentChat = {id: chatDoc.id, userIds: [chatDoc.data.users, this.localUser.uid]};
                            this.chatDialog = true;
                        })
                        .catch(error => {
                            //Notify that the user wasn't able to join the chat
                            console.log(error); //eslint-disable-line
                        })
                    } else {
                        //Then open the chat as normal
                        this.currentChat = {id: chatDoc.id, userIds: chatDoc.data.users};
                        this.chatDialog = true;
                    }
                })
                .catch(error => {
                    if (error === "No chat exists"){
                        const userIds = this.localOrg.users.map(u => u.id);
                        //Then the chat doesn't exist but we need to create a new one
                        this.chatDataService.createNewChat(`${this.localOrg.name}`, "Group", userIds, this.localOrg.id)
                        .then((result) => {
                            //Once we have successfully created the chat we can then get the existing chat as normal (so that we can open and join it)
                            console.log(result); //eslint-disable-line

                            this.chatDataService.getExistingChat(null, "Group", this.localOrg.id)
                            .then(chatDoc => {
                                this.currentChat = {id: chatDoc.id, userIds: chatDoc.data.users};
                                this.chatDialog = true;
                            })
                        })
                        .catch((error) => {
                            Toast.fire({  icon: 'error',  title: `Could not open chat: ${error}`});
                        })
                    } else {
                        //Otherwise, there was a real error report this back
                        Toast.fire({  icon: 'error',  title: `Could not open chat: ${error}`});
                    }
                })
            }
        },
        closeChatDialog(){
            this.chatDialog = false;
            this.currentChat = {};
        },
        random_rgba() {
            var o = Math.round, r = Math.random, s = 255;
            return 'rgba(' + o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s) + ',' + r().toFixed(1) + ')';
        },
        isAdmin(id){
            var adminIds = [];
            this.localOrg.users.map(function(user){
                if(user.admin === true){
                    adminIds.push(user.id);
                }
            })
            //Need to search through users list now
            if (adminIds.includes(id)){
                return true;
            } else {
                return false;
            }
        }
    },
    computed: {
        getLabel(){
            var fullLabel = this.label;
            return fullLabel;
        },
        myOrg(){
            if (this.localOrg.id === this.localUser.orgid){
                return true;
            } else {
                return false;
            }
        },
        hasAdminRights(){
            return this.isAdmin(this.localUser.uid);
        }
    },
    watch: {
        org: {
            // the callback will be called immediately after the start of the observation
            immediate: false, 
            handler (val) {
                if (val !== null){
                    this.localOrg = val;
                    //Reload the users to update the UserManagement Screen
                    this.loadUsers();
                }
            }
        },
        user: {
            // the callback will be called immediately after the start of the observation
            immediate: false, 
            handler (val) {
                if (val !== null){
                    this.localUser = val;
                }
            }
        }

    },
    data: () => ({
        orgStats: {
            totalTreatments: 0,
            totalUpvotes: 0,
            categories: [{name: "Other", count: 0}]
        },
        localOrg: {},
        localUser: {},
            categoryChartOptions: {
            responsive: true,
            maintainAspectRatio: false
        },
        categoryData: {
            labels: [],
            datasets: [
                {
                label: 'Categories',
                backgroundColor: [
                ],
                data: []
                }
            ]
        },
        treatmentItems: [],
        userItems: [],
        treatmentsLoading: false,
        usersLoading: false,
        chatDialog: false,
        currentChat: {}
    })    
}
</script>
